import { useEffect, useState } from "react";
import client from "@/lib/api";
import { SPONSORS, logoCardCls } from "@/lib/constants";

export default function SponsorStrip() {
  const [items, setItems] = useState(SPONSORS);

  useEffect(() => {
    client.get("/sponsors").then((r) => {
      if (Array.isArray(r.data) && r.data.length) {
        setItems(r.data.filter((s) => !["partner", "masthead-left", "masthead-right"].includes(s.slot)));
      }
    }).catch(() => {});
  }, []);

  return (
    <section data-testid="sponsor-strip" className="bg-white dark:bg-legend-paper border-y border-slate-200 dark:border-slate-800">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <p className="text-center text-[11px] font-mono uppercase tracking-[0.3em] text-slate-400 mb-4">La nostra Pubblicità</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {items.map((s) => (
            <a
              key={s.id || s.name}
              href={s.url || "#"}
              target="_blank"
              rel="noreferrer"
              data-testid={`strip-sponsor-${(s.name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              title={s.name}
              className={`flex items-center justify-center rounded-sm p-4 h-24 hover:border-legend-red hover:shadow-md transition-all ${logoCardCls(s.name)}`}
            >
              <img src={s.logo} alt={s.name} className="max-h-full max-w-full object-contain" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
